import React, { useEffect, useState, useRef  } from "react"
import './discover.css';

import { ReactComponent as ArrowPrevIcon } from "../../assets/svg/arrow-previous.svg";
import { ReactComponent as ArrowNextIcon } from "../../assets/svg/arrow-next.svg";
import { ReactComponent as MeetQIcon } from "../../assets/svg/meetq-logo.svg";
import { ReactComponent as ScanIcon } from "../../assets/svg/scan.svg";
import { ReactComponent as ArrowDownIcon } from "../../assets/svg/arrow-down.svg";
import { ReactComponent as SlotFilterIcon } from "../../assets/svg/filter-search.svg";
import { ReactComponent as SlotCloseIcon } from "../../assets/svg/close-1.svg";
import { ReactComponent as FilterCloseIcon } from "../../assets/svg/close-filter.svg";
import { ReactComponent as CalendarIcon } from "../../assets/svg/calendar-outline.svg";
import RoomImage from "../../assets/png/room-view-image.png";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { format, parse } from 'date-fns';
import axios from 'axios';
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Header from "../common/Header";
import { Form, Button, InputGroup, Toast,  ToastContainer  } from "react-bootstrap";
import { getCookie } from '../getcookie.js';
import LoaderModal from "../common/Loader.js";
import RepeatBookingModal from "../Modals/repeatBookingModal.js";
import { handleBookingStatus } from './discover-services.js';
import DiscoverModal from "../Modals/discoverModal.js";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import moment from "moment";
import { useGlobal } from "../../GlobalContext.js";
export default function DiscoverView(){
   const { selectedMenu, setSelectedMenu } = useGlobal();
  const apiUrl = process.env.REACT_APP_API_URL;
  
   const navigate = useNavigate();
    const location = useLocation();
    const { id, date,formatted_date, } = location.state || {};
    const scrollRefs = useRef();

  const scrollLeft = () => {
    const ref = scrollRefs.current;
    if(ref){
    ref.scrollBy({ left: -100, behavior: "smooth" }); 
    }
  };

  const scrollRight = () => {
    const ref = scrollRefs.current;
    if(ref){
        ref.scrollBy({ left: 100, behavior: "smooth" }); 
    }
  };
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000
  };
  const [showModal, setShowModal] = useState(false);
  const [showRepeatBookingModal, setShowRepeatBookingModal] = useState(false);
  const [selectedOffice, setOfficeValue] = useState('');
  const [selectedFloor, setFloorValue] = useState('');
  const handleDropdownChange = (value) => {
    setOfficeValue(value); 
   
  };
  const [selectedDate, setSelectedDate] = useState(moment(new Date(date)).format("YYYY-MM-DD"));
  const [selectedDateFormat, setSelectedDateFormat] = useState('');
 function formatDate2(inputDate) {
          if(inputDate!==undefined){
           // Parse the input date (MM/DD/YYYY format)
           const parsedDate = parse(inputDate, 'MM/dd/yyyy', new Date());
           // Format the date
           return format(parsedDate, "yyyy-MM-dd");
          }else{
            return "";
          }
         }

  const [showPicker, setShowPicker] = useState(false);


  const [meetingRoomDetails, setMeetingRoom] = useState({});
  const [selectedSlotPeriod, setSelectedSlotPeriod] = useState('');
  const [selectedPeriodFrom, setSelectedPeriodFrom] = useState('');
  const [selectedPeriodTo, setSelectedPeriodTo] = useState('');
 const [errorMessage, setErrorMessage] = useState(''); 
 const [customSlotErrorMessage, setCustomSlotErrorMessage] = useState({date:'',  from:'',  to:'',} );

  const [selectedCategory, setCategoryValue] = useState('');
    const [selectedSlot, setSlotValue] = useState('30 mins');
    const [selectedBookId, setBookId] = useState([]);
   
      const [categoryList, setCategory] = useState([]);

      const [floorList, setFloors] = useState([]);
      const [roomList, setRooms] = useState([]);
      const [isOpen, setIsOpen] = useState(false);
       const [loading, setLoading] = useState(false);
            const [error, setError] = useState(null);

      const openModal = (id) =>{
       
        setIsOpen(true);
      };
      const closeModal = () => setIsOpen(false);
      const [selectedRoomId, setRoomId] = useState(-1);
      const [selectedRoomIndex, setRoomIndex] = useState(-1);
     const [availableList, setAvailable] = useState([]);
     const [slotList, setSlotList] = useState([]);
      const [startTimeInputValue, setStartTimeInputValue] = useState("");
      const [endTimeInputValue, setEndTimeInputValue] = useState("");
      const [startTime12HourInputValue, setStartTime12HourInputValue] = useState("");
      const [endTime12HourInputValue, setEndTime12HourInputValue] = useState("");
       const alertRef = useRef(null);
      const handleClickOutside = (event) => {
        if (alertRef.current && !alertRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
 useEffect(() => {
          // Attach event listener to the document
          document.addEventListener("mousedown", handleClickOutside);
          return () => {
            // Clean up event listener on unmount
            document.removeEventListener("mousedown", handleClickOutside);
          };
        }, []);
     
      const availableTitle = {fontSize:"12px", fontWeight:"400", color: '#81878C',marginBottom:'8px',};
      const availableName = {fontSize:"12.5px", fontWeight:"400", color: '#21272C'};
      const slotTitle = {fontSize:"13px", fontWeight:"700", color: '#1E1E1E'};
      const slotTitleSelected = {fontSize:"12px", fontWeight:"500", color: '#842234'};
     
      
      
      
  function commonFormatDate(inputDate, formatString) {
    try {
      if (inputDate !== undefined) {
        /* // Parse the input date (MM/DD/YYYY format)
        const parsedDate = parse(inputDate, "MM/dd/yyyy", new Date());
 
        // Format the date
        return format(parsedDate, "EEEE, dd MMM yyyy");"dddd, DD MMM YYYY" */
        return moment(moment(inputDate, "YYYY-MM-DD").toDate()).format(formatString)
      } else {
        return "";
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
    }
  }
        useEffect(() => {
           setSelectedMenu("Discover");
          setSelectedDateFormat(date);
          setSelectedDate(moment(new Date(date)).format("YYYY-MM-DD") );
          fetchOptions();
          
         
        
        },[]); 

        useEffect(() => {
          if(startTimeInputValue!=="" && endTimeInputValue!==""){
            getCustomSlots();
          }         
        },[startTimeInputValue,endTimeInputValue]); 
       
        const fetchOptions = async () => {
          setLoading(true);
          setError(null);
         
          try {
            const response = await axios.get(apiUrl+`discover/`+id, {
             
              headers: {
                  'Content-Type': 'application/json; charset=UTF-8',
                  "Accept": "application/json",
          
                  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
                  "Authorization":getCookie("mawalog")
                }
            });
        
          if(response.data.success===true){
            console.log("booking:", response.data.booking);
            setMeetingRoom(response.data.room??{});  
            setAvailable(meetingRoomDetails["available"]!=null && meetingRoomDetails["available"]!==""?meetingRoomDetails["available"].split(","):[]); 
                  
        }
        console.log("Room List:", roomList);
        console.log("Room List Length:", roomList.length);
          } catch (err) {
            console.error("Error fetching options:", err);
            setError("Failed to fetch options. Try again.");
          } finally {
            setLoading(false);
          }
        };
  
        const getSlots = async () =>   {
          try {
            console.log("get_slots api called");
            const data={
              "office_id":selectedOffice,
            "floor": selectedFloor,
            "date":selectedDate, 
            "from": "",
            "to": "",
            "id": [id],
            "range": selectedSlot
            };
  
            const headers={
              'Content-Type': 'application/json;',
              "Accept": "application/json",          
              "Access-Control-Allow-Origin": "*", 
              "Authorization":getCookie("mawalog")
            };
            const response = await axios.post(apiUrl+"get_slots",  
              data,
              { headers:headers}
            );
              if (response.statusCode === 400) {
              } else {
                if (response.data.success === true) {
                  const index = response.data.data
                          .findIndex(element => element.id === id);
                  
                      if (index>-1) {
                        console.log('slots', response.data.data[index]["slots"]);
                        setSlotList(response.data.data[index]["slots"]);
                       
                    }                 
                    await new Promise((resolve) =>
                      setTimeout(() => resolve(), 1000)
                    );
                    const today = new Date().toISOString().split('T')[0]; // "YYYY-MM-DD"
                    const selected = new Date(selectedDate).toISOString().split('T')[0];
                    console.log('date today',today);
                    console.log('date selected',today);
                    if(today === selected){
                      var slotIndex=-1;
                      if(response.data.data.length>0){
                        const now = new Date();
                        const hours = now.getHours().toString().padStart(2, '0');
                        const minutes = now.getMinutes().toString().padStart(2, '0');
                        /* for (const [index, slot] of response2.data.data[0]["slots"]) {
                          const isCurrentTime=  compareTimes(`${hours}:${minutes}`,slot["from"]); 
                          if (isCurrentTime === true) {                              
                            break; // Exit the loop
                          }
                          
                        } */
                         response.data.data[0]["slots"].some((slot, index) => {
                          console.log('current time.....',`${hours}:${minutes}`)
                          console.log('slot time.....',slot["from"])
                          const isCurrentTime=  compareTimes(slot["from"],slot["to"],`${hours}:${minutes}`); 
                          console.log('isCurrentTime.....',isCurrentTime)
                          if (isCurrentTime === true) {   
                            slotIndex=  index;                         
                           return true; // Exit the loop
                          }
                          return false;
                        });
                       
                      }
                      console.log('date equal');
                      response.data.data.forEach(async(roomobj) => {
                            /*  for (var roomobj in response2.data.data) { */
                               
                           
                                
                               console.log('ref slotIndex',slotIndex)
                               console.log('ref Index',index)
                               const ref = scrollRefs.current;
                               if(ref){
                                 console.log('ref exist')
                                
                                 ref.scrollTo({
                                  left: 0,
                                  behavior: 'smooth',
                                });  
                                await new Promise((resolve) =>
                                  setTimeout(() => resolve(), 500)
                                );
                                ref.scrollBy({ left: 126 * (slotIndex+1), behavior: "smooth" }); 
                               }
    
                                           
                         });
                    }
              }
            } 
          } catch (err) {
            console.error("Error fetching options:", err);
            setError("Failed to fetch options. Try again.");
          } finally {
            setLoading(false);
          }
       
        };

        const getCustomSlots = async () =>   {
          setErrorMessage('');
          setCustomSlotErrorMessage({date:'',  from:'',  to:'',});
          try {
            console.log("get_slots api called");
            const data={
              "room_id":meetingRoomDetails["id"],
            "date":selectedDate, 
            "from": startTimeInputValue.slice(0, 5),
            "to": endTimeInputValue.slice(0, 5),
            "repeat_booking": false, 
            };
  
            const headers={
              'Content-Type': 'application/json;',
              "Accept": "application/json",          
              "Access-Control-Allow-Origin": "*", 
              "Authorization":getCookie("mawalog")
            };
            const response = await axios.post(apiUrl+"check_slot_availability",  
              data,
              { headers:headers}
            ).then((response) => {
              if (response.statusCode === 400) {
              } else {
                if (response.data.success === true) {
                  if (response.data.available === true) {
                    setErrorMessage('');
                    setSelectedSlotPeriod(startTime12HourInputValue +' - '+endTime12HourInputValue);
                    setSelectedPeriodFrom(startTimeInputValue.slice(0, 5));
                    setSelectedPeriodTo(endTimeInputValue.slice(0, 5));  
                } else { 
                  setErrorMessage('Slot not available');                
                  setSelectedSlotPeriod('');
                  setSelectedPeriodFrom('');
                  setSelectedPeriodTo('');                  
                }
              }
            } 
            }).catch((error) => {
              if (error.response) {
                console.error("Error Status:", error.response.status);
                console.error("Error Data:", error.response.data);
                if(error.response.status===400){
                  var errorMsg= error.response.data.error;
                  
                  console.log('error msg',errorMsg)
                 
                  }
                  setErrorMessage(error.response.data.message); 
                  setErrorValue(error.response.data.error);
              } else {
                console.error("Request failed:", error.message);
              }
            }); ;
             
          } catch (err) {
            console.error("Error fetching options:", err);
            setError("Failed to fetch options. Try again.");
          } finally {
            setLoading(false);
          }
       
        };
        const setErrorValue = async (errorMsg) =>   {
          setCustomSlotErrorMessage({
            date:errorMsg['date']!==undefined?errorMsg['date'][0]:'',
            from:errorMsg['from']!==undefined?errorMsg['from'][0]:'',
            to:errorMsg['to']!==undefined?errorMsg['to'][0]:'',           
          }); 
          
        }
        useEffect(() => {  
          if(selectedSlot!=='custom'){
            getSlots();
          }else{
            getCustomSlots();
          }      
         
        },[selectedDate]);
   useEffect(() => {          
             getSlots();
           },[meetingRoomDetails]);
 useEffect(() => {   
  if(selectedSlot!=='custom'){       
          getSlots();
  }
        },[selectedSlot]);

        function convertTo12HourFormat(time24) {
          // Split the time string into hours and minutes
          const [hours24, minutes] = time24.split(":");
        
          // Convert to a number and calculate 12-hour format
          const hours = parseInt(hours24, 10) % 12 || 12; // Convert 0 to 12 for midnight
          const period = parseInt(hours24, 10) >= 12 ? "PM" : "AM";
        
          // Return formatted time
          return `${hours}:${minutes} ${period}`;
        }
        const compareTimes = (fromTime,toTime, currentTime) => {
          // Split the times into hours and minutes
          const [hours1, minutes1] = fromTime.split(':').map(Number);
          const [hours2, minutes2] = toTime.split(':').map(Number);
          const [hours3, minutes3] = currentTime.split(':').map(Number);
        
          // Convert both times to total minutes
          const totalFromMinutes = (hours1 * 60) + minutes1;
          const totalToMinutes = (hours2 * 60) + minutes2;
          const totalCurrentMinutes = (hours3 * 60) + minutes3;
          // Compare the total minutes
         if (totalFromMinutes < totalCurrentMinutes && totalToMinutes>totalCurrentMinutes) {
            return true; 
          } else {
            return false; 
          }
        };
         const [bookingDetails, setBookingDetails] = useState(null);
 const getBookedStatus = async (roomId,bookingSlot) => {
    console.log(bookingSlot)
    setShowModal(false);    
    try {
      const result = await handleBookingStatus(roomId,selectedDate,bookingSlot); // Wait for API response
      if (result.success === true) {
        setBookingDetails(result.details);
        setShowModal(true);
      }
       // Update state
    } catch (error) {
      console.error('Error adding item:', error);
    }
    console.log("Successfully called");
  
  
  };

    return  (<Container fluid className="GTWalsheimTrial px-0">
      <div>
      {showModal && <DiscoverModal bookingData={bookingDetails} show={showModal} onHide={() =>{setShowModal(false);setBookingDetails(null);}} />}
    </div>
       <div>
                        {showRepeatBookingModal && <RepeatBookingModal roomId={id} show={showRepeatBookingModal} onHide={() => setShowRepeatBookingModal(false)} />}
                    </div>
             {/*  <Header selectedTab={'Discover'}/>   */}
              <Row className="flex-wrap px-3" style={{height:'calc(100vh - 68px)',overflow: 'auto',scrollbarWidth: "none",msOverflowStyle: "none", justifyContent:'center',}}>
             
        <Col  xl={8} style={{padding: '16px', justifyContent:'center',}}> 
        <div style={{display: 'flex', alignItems: 'center', justifyContent:'start',}}>
        <div onClick={()=>{ navigate("/");}} style={{cursor: "pointer",fontSize:"13px", fontWeight:"400", color: '#1e1e1e'}} >
            Discover
            </div> &nbsp;&nbsp; <ArrowNextIcon/>&nbsp;&nbsp;
            <div style={{fontSize:"13px", fontWeight:"500", color: '#842234'}} >
            {meetingRoomDetails['room']??''}
            </div>
            </div>
            &nbsp;&nbsp;
            <div style={{padding: "16px",borderRadius: "24px", background: '#ffffff'}}>
           {(meetingRoomDetails.images===undefined || meetingRoomDetails.images.length===0) && ( <img src={meetingRoomDetails['image']!=null && meetingRoomDetails['image']!==''?meetingRoomDetails['image']: RoomImage} alt="room" className="w-100" style={{  height: '279px', }} />)}
           {(meetingRoomDetails.images!==undefined && meetingRoomDetails.images.length>0) && ( <Slider {...settings}>
                {meetingRoomDetails.images.map((img, index) => (
                  <div key={index}>
                    <img src={img} alt={`Slide ${index}`} style={{ width: "100%", height: '279px', objectFit: 'scale-down'}}  />
                  </div>
                ))}
              </Slider>)}
            <div style={{fontSize:"20px", fontWeight:"700", color: '#1E1E1E'}} >
            {meetingRoomDetails['room']??''}
            </div>

            <div style={{display: 'flex', alignItems: 'center', justifyContent:'start',}}>
        <div style={{fontSize:"14px", fontWeight:"500", color: '#842234'}} >
        {meetingRoomDetails['capacity']??'0'} Seater
            </div> &nbsp;&nbsp; <div style={{width:'3px',height:'3px', backgroundColor:'#D9D9D9'}}></div>&nbsp;&nbsp;
            <div style={{fontSize:"14px", fontWeight:"400", color: '#81878C'}} >
            {meetingRoomDetails['category']??''}
            </div>
            </div>
            &nbsp;&nbsp;
            <div style={availableTitle} >
            Available :
            </div>
            <Col lg={8} style={{display: 'flex',flexWrap: 'wrap', }}>
            {availableList!=null && availableList!=="" && availableList.map((available, index) => (
          <div key={`${index}-available`} style={{ height: '24px',marginRight:'6px',marginBottom:'4px', paddingLeft:'8px',paddingRight:'8px',  borderRadius: '8px',  display:'flex',justifyContent:"center", alignItems:"center", backgroundColor: '#F5F7F9' }}>
          <div style={availableName}>{available}</div>   
         </div>
        ))}
            </Col>
            </div>
            &nbsp;&nbsp;
            <div style={{height:'132px',padding: "16px",borderRadius: "24px", background: '#ffffff'}}>
            <div style={{fontSize:"20px", fontWeight:"700", color: '#1E1E1E'}} >
            Office details
            </div>
            <div style={{height:'68px',marginTop:'8px', padding: "16px",borderRadius: "16px", background: '#FFF0F3'}}>
              <div style={{display: 'flex',}}>
              <div style={{width:'36px', height:'36px',borderRadius: "100px", }}>
              <img src={meetingRoomDetails['org_image']!=null && meetingRoomDetails['org_image']!=''?meetingRoomDetails['org_image']: RoomImage}   alt="org" style={{ width:'36px', height:'36px', borderRadius:'100px' }} />
              </div>
              <div style={{marginLeft:'16px'}}>
              <div style={{fontSize:"14px", fontWeight:"500", color: '#1E1E1E'}} >
              {meetingRoomDetails['office']??''}
            </div>
            <div style={{fontSize:"12px", fontWeight:"400", color: '#1E1E1E', opacity:'60%'}} >
            {meetingRoomDetails['floor_label']??''}
            </div>
              </div>
              </div>
            </div>           
            </div>
           
            &nbsp;&nbsp;
            <div style={{padding: "16px",borderRadius: "24px", background: '#ffffff'}}>
            <div style={{fontSize:"20px", fontWeight:"700", color: '#1E1E1E'}} >
            Choose date
            </div>
            <input id="selected_date"
                        type="date" value={selectedDate} onChange={(event) => { setSelectedDate(event.target.value); }}
                        style={{
                          height: "40px",
                          borderRadius: "10px",
                          border: "0.7px solid #E5E5E5",
                          padding: "16px",
                        }}
                       class="date-picker w-100"
                        placeholder="DD-MM-YYYY"
                      />
              {/* <div style={{marginTop:'8px', position: 'relative',  height:"40px" }}>
                    
                    <div style={{ display: 'flex', alignItems: 'center', border: '0.7px solid #E5E5E5', borderRadius: '8px', padding: '10px 12px' }}>
                      <input
                        type="text"
                        value={selectedDate ?formatDate(selectedDate.toLocaleDateString()) : ''}
                        onClick={() => setShowPicker(!showPicker)}
                        readOnly
                        style={{ flex: 1, border: 'none', outline: 'none', cursor: 'pointer' }}
                        placeholder="Select a date"
                      />
                      <CalendarIcon style={{ cursor: 'pointer', color: '#842234' }} onClick={() => setShowPicker(!showPicker)} />
                    </div>
              
                   
                    {showPicker && (
                      <div style={{ position: 'absolute', top: '40px', zIndex: 100, background: '#fff', border: '1px solid #ccc', borderRadius: '4px', boxShadow: '0px 4px 6px rgba(0,0,0,0.1)' }}>
                        <DayPicker mode="single" selected={selectedDate} onSelect={handleDateChange} />
                      </div>
                    )}
                  </div>  */}    
                  <div  style={{textAlign:'start',marginTop:'8px',}} className="text-muted" >
                                 { customSlotErrorMessage.date!=="" && (<div style={{color:'#ff0000'}}>{customSlotErrorMessage.date}</div>)} 
                                  </div>
                    <Col style={{marginTop:'16px',}}  className="justify-content-start justify-content-sm-start justify-content-md-end" >
             
         <div style={{display: 'flex',alignItems: 'center', justifyContent:'space-between',}}>
        <div style={slotTitle}>Select your slot </div>
        <div key="more" style={{ position: "relative" }}>
        <div onClick={() =>setIsOpen(true)} style={{cursor: "pointer", width: '79px',height: '28px',  borderRadius: '62px', border: '0.8px solid #842234',  display:'flex',justifyContent:"center", alignItems:"center", backgroundColor: '#FFFFFF' }}>
            <div style={slotTitleSelected}>{selectedSlot}</div>&nbsp; <div><ArrowDownIcon/></div>   
            </div>
            {isOpen && (
                                                 <div ref={alertRef} style={{ position: "absolute",
                                                  top: "40px",
                                                  left: "50%",
                                                  transform: "translateX(-50%)",
                                                  backgroundColor: "#ffffff",
                                                  color: "#1E1E1E",
                                                  padding: "16px",
                                                  borderRadius: "16px",
                                                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                                  zIndex: 1,alignItems:'end', }}>
                                                  <div  style={{cursor: "pointer",width:'150px', height:'36px', fontSize:"14px", fontWeight:"500",  color: '#1E1E1E',display: 'flex',alignItems:'center',justifyContent:'start'}} 
                                                  onClick={()=>{
                                                    setSlotValue("30 mins");
                                                    setIsOpen(false);
                                                  }}>
                                                  30 mins slot
                                        </div>
                                        <div   style={{cursor: "pointer",width:'150px',height:'36px', fontSize:"14px", fontWeight:"500", color: '#1E1E1E', display: 'flex',alignItems:'center',justifyContent:'start'}} 
                                        onClick={()=>{
                                          setSlotValue("1 hour");  
                                          setIsOpen(false);                                        
                                        }}>
                                        One hour slot
                                        </div>
                                        <div   style={{cursor: "pointer",width:'150px',height:'36px', fontSize:"14px", fontWeight:"500", color: '#1E1E1E', display: 'flex',alignItems:'center',justifyContent:'start'}} 
                                       onClick={()=>{
                                        setSlotValue("custom"); 
                                        setIsOpen(false);                                       
                                       }} >
                                        Customized time
                                        </div>
                                        <div style={{ cursor: "pointer", width: '150px', height: '36px', fontSize: "14px", fontWeight: "500", color: '#1E1E1E', display: 'flex', alignItems: 'center', justifyContent: 'start' }}
                            onClick={() => {
                             setShowRepeatBookingModal(true);
                            }} >
                            Repeat
                          </div>
                                                 </div>
                                               )}
        </div>

        </div>  
        {selectedSlot!=='custom' && ( <Row  style={{display: 'flex', marginTop:'8px', alignItems: 'center', justifyContent:'space-between',}}>
        <Col xs={1}  key={`arrow-btn-1`} style={{height: '40px',display: 'flex',justifyContent:"end", alignItems:"center", }}>
        <div style={{width: '28px',height: '28px',justifyContent:"start", }}>
        <div  onClick={() =>scrollLeft()}  style={{cursor: "pointer", width: '28px', height: '28px',display: 'flex',justifyContent:"center", alignItems:"center",  borderRadius: '100px', border: '0.5px solid #D4DDE7',  backgroundColor: '#FFFFFF', color:'#842234' }}>
             <div><ArrowPrevIcon/></div>   
            </div>
            </div>
            </Col>
            <Col xs={10} ref={scrollRefs} style={{paddingLeft:'8px',display: 'flex',justifyContent:"start", alignItems:"center", whiteSpace: "nowrap", height: '40px',overflowX: "scroll",overflowY: "hidden",scrollbarWidth: "none",    msOverflowStyle: "none", }}>
           
            {slotList.map((slot,slotIndex) => (
          <div onClick={() =>{
            if(slot["expired"]===false && slot["available"]===true){
              setSelectedSlotPeriod(slot["period"]);
              setSelectedPeriodFrom(slot["from"]);
              setSelectedPeriodTo(slot["to"]);             
            }else{
              if(slot["id"]!==0){
                getBookedStatus(id,slot);
              }
              }            
          }}
          key={`${slotIndex}`} style={{/* width: '120px', */cursor: "pointer", height: '32px',marginRight:'6px',marginBottom:'4px', paddingLeft:'8px',paddingRight:'8px',  borderRadius: '8px',  display:'flex',justifyContent:"center", alignItems:"center", 
            backgroundColor: selectedSlotPeriod===slot["period"]?'#EDFFF5': (slot["available"] === false?'#FFF1F4':(slot["expired"] === true?'#F5F5F5':'#FFFFFF')),
            border: selectedSlotPeriod===slot["period"]?'1px solid #20824A': (slot["available"] === false?'1px solid #E93153':(slot["expired"] === true?'1px solid #E5E5E5':'1px solid #E5E5E5')), }}>
          <div style={availableName}>{slot["period"]}</div>   
         </div>
        ))}           
            </Col>
           <Col  xs={1} key={`arrow-btn-2`} style={{height: '40px',display: 'flex',justifyContent:"start", alignItems:"center", }}>
           <div style={{width: '28px',height: '28px',justifyContent:"start", }}>
            <div  onClick={() =>scrollRight()} style={{ cursor: "pointer", width: '28px',height: '28px',  borderRadius: '100px', border: '0.5px solid #D4DDE7',  display:'flex',justifyContent:"center", alignItems:"center", backgroundColor: '#FFFFFF', color:'#842234' }}>
             <div><ArrowNextIcon/></div>   
            </div>
            </div>
            </Col>
            </Row>  )}
            {selectedSlot==='custom' && (
            <Row>
                          <Col>
                          <div  className="material-form-group">
                          <input
                            type="time"
                            id="material-input"
                            className="form-control material-input"
                            placeholder=" "
                            value={startTimeInputValue}
                            onChange={(event) => {
                              setStartTimeInputValue(event.target.value); 
                              setStartTime12HourInputValue(convertTo12HourFormat(event.target.value))
                            }}
                            style={{cursor: "pointer",}}
                          />
                          <label htmlFor="material-input" className="material-label">
                          Start Time
                          </label>
                        </div>
                        { customSlotErrorMessage.from!=="" && (<Form.Text  style={{textAlign:'start',}} className="text-muted" >
                                 <div style={{color:'#ff0000'}}>{customSlotErrorMessage.from}</div>
                                  </Form.Text>)} 
                                   
                          </Col>
                          <Col>
                          <div  className="material-form-group">
                          <input
                            type="time"
                            id="material-input"
                            className="form-control material-input"
                            placeholder=" "
                            value={endTimeInputValue}
                            onChange={(event) => {
                              setEndTimeInputValue(event.target.value); 
                              setEndTime12HourInputValue(convertTo12HourFormat(event.target.value))
                            }}
                            style={{cursor: "pointer",}}
                          />
                          <label htmlFor="material-input" className="material-label">
                          End Time
                          </label>
                        </div>
                        { customSlotErrorMessage.to!=="" && (<Form.Text  style={{textAlign:'start',}} className="text-muted" >
                                 <div style={{color:'#ff0000'}}>{customSlotErrorMessage.to}</div>
                                  </Form.Text>)} 
                          </Col>
                        </Row>  
                        )} 
            
            { errorMessage!=="" && ( <div style={{ fontSize:"14px", fontWeight:"700", color: '#FF4444' }}> {errorMessage}  </div>)}
            <div onClick={() => {
              if(selectedSlotPeriod!==''){
      navigate("/book-meeting", { state: {id: meetingRoomDetails["id"], date:moment(selectedDate).format("YYYY-MM-DD"),formatted_date:commonFormatDate(selectedDate,"dddd, DD MMM YYYY"), selected_slot: selectedSlotPeriod,selected_slot_from: selectedPeriodFrom,selected_slot_to: selectedPeriodTo,  } });
              }
    }} style={{cursor: "pointer", height: '36px',marginTop:'8px',  borderRadius: '12px',  display:'flex',justifyContent:"center", alignItems:"center", backgroundColor: '#842234', opacity: selectedSlotPeriod!==''?1:0.7 }}>
             <div style={{ fontSize:"14px", fontWeight:"700", color: '#F3F6F9' }}>Book Slot</div>   
            </div>
      
    
    </Col> 
            </div>
        </Col>
              </Row>
              <LoaderModal show={loading} />
        </Container>)



}